<template>
  <div>
    <h5
      style="
        margin: 32px 0 24px;
        font-weight: bold;
        font-size: 18px;
        line-height: 26px;
        color: #231f1f;
      "
    >
      Details
    </h5>
    <b-row no-gutters class="my-2" align-v="center">
      <b-col cols="12"
        ><span
          class="required"
          style="
            font-size: 14px;
            line-height: 22px;
            margin-bottom: 8px;
            color: #231f1f;
          "
          >Name of the person you are giving on behalf of</span
        ></b-col
      >
      <b-col cols="12"
        ><b-input v-model="checkout.On_Behalf_Of" placeholder="Name" required
      /></b-col>
    </b-row>
    <b-form-group>
      <b-input-group size="sm"
        ><b-input-group-prepend is-text
          ><span
            >Send the person message via email (Optional)</span
          ></b-input-group-prepend
        ><b-input
          v-model="checkout.On_Behalf_Of_Email"
          placeholder="Email (Optional, leave blank if you do not wish to send a message)"
          type="email"
      /></b-input-group>
      <b-input-group size="sm" v-if="checkout.On_Behalf_Of_Email"
        ><b-input-group-prepend is-text
          ><b-icon
            icon="chat-square-text"
            class="mx-2" /></b-input-group-prepend
        ><b-textarea
          v-model="checkout.On_Behalf_Of_Msg"
          placeholder="Leave a Message"
          rows="3"
          max-rows="6"
      /></b-input-group>
    </b-form-group>

    <hr />
    <h5
      style="
        margin: 32px 0 24px;
        font-weight: bold;
        font-size: 18px;
        line-height: 26px;
        color: #231f1f;
      "
    >
      Your Personal details
    </h5>
    <fields :checkout="checkout" />
  </div>
</template>

<script>
import fields from "./fields.vue";
export default {
  name: "inhonor",
  components: {
    fields,
  },
  props: {
    checkout: Object,
  },
};
</script>

<style></style>
